import axiosInstance from "./api_helper";

const supplierService = {
    search: async ({ query = '', page = 0, size = 10 }) => {
        return axiosInstance.get('/api/fournisseurs/search', {
            params: { query, page, size }
        });
    },
    delete: async (id) => {
        return axiosInstance.delete(`/api/fournisseurs/${id}`);
    },
    save: async (payload) => {
        return axiosInstance.post(`/api/fournisseurs`, JSON.stringify(payload));
    },
    update: async (payload) => {
        return axiosInstance.put(`/api/fournisseurs/${payload.id}`, JSON.stringify(payload.data));
    },

};
export default supplierService;
